import script from "./WageEmployeeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageEmployeeList.vue?vue&type=script&setup=true&lang=ts"

import "./WageEmployeeList.vue?vue&type=style&index=0&id=0011b161&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0011b161"]])

export default __exports__